import type { TableRow } from "./product-route-contracts";

export const companyRows: TableRow[] = [
  {
    id: "company-1",
    company: "Acme Leadership",
    status: "active",
    linkedPrograms: "1 active program",
    linkedCohorts: "1 active cohort",
    lifecycle: "archive requires impact confirmation"
  }
];

export const companyDiscoveryRows: TableRow[] = [
  ...companyRows,
  {
    id: "company-2",
    company: "Globex Growth",
    status: "active",
    linkedPrograms: "1 active program",
    linkedCohorts: "1 active cohort",
    lifecycle: "hidden unless role scope authorizes"
  }
];

export const programRows: TableRow[] = [
  {
    id: "program-1",
    program: "Executive Coaching",
    company: "Acme Leadership",
    coach: "Coach One",
    status: "active",
    lifecycle: "assignment review"
  }
];

export const programDiscoveryRows: TableRow[] = [
  ...programRows,
  {
    id: "program-2",
    program: "Finance Coaching",
    company: "Globex Growth",
    coach: "Coach Two",
    status: "active",
    lifecycle: "hidden unless role scope authorizes"
  }
];

export const programTypeaheadOptions = programDiscoveryRows.map((row) => ({
  id: row.id,
  label: String(row.program),
  company: row.company
}));
